export const INITIAL_VALUES = {
  date_start: '',
  date_finish: '',
  user_id: null,
};
